import FormCondoUsers from "../FormCondoUsers/FormCondoUsers";
import { useLocation, useParams } from "react-router-dom";
import "./CadastroCondoUsers.css";
import { useEffect, useState } from "react";
import CadastroContainer from "../../../components/CadastroContainer/CadastroContainer";
import CondoUserService from "../../../services/CondoUserService";

const CadastroCondoUsers = () => {
	const { condoUserId } = useParams();
	const { state } = useLocation();
	const [type, setType] = useState("");
	const [condoUser, setCondoUser] = useState(state);

	async function loadCondoUser(id) {
		const response = await CondoUserService.getByUUIDCondoUser(id);
		if (response.data) {
			setCondoUser(response.data);
		}
	}

	useEffect(() => {
		setType(condoUserId || state ? "edicao" : "cadastro")

		if (condoUser) {
			setCondoUser(state);
			return;
		}

		if (condoUserId) {
			loadCondoUser(condoUserId);
		}
	}, [state, condoUserId]);

	return (
		<CadastroContainer>
			<FormCondoUsers condoUser={condoUser} type={type} />
		</CadastroContainer>
	);
};

export default CadastroCondoUsers;
